import { render, staticRenderFns } from "./recipe-facets-filter.vue?vue&type=template&id=317c83c3&"
import script from "./recipe-facets-filter.vue?vue&type=script&lang=js&"
export * from "./recipe-facets-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports